import React from 'react';
import PropTypes from 'prop-types';

function CheckIcon({
  color, containerColor, label, onClick, size,
}) {
  return (
    <svg
      onClick={onClick}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={label}
    >
      <circle cx="12" cy="12" r="12" fill={containerColor} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0912 7.27271C18.5013 7.65506 18.5237 8.29741 18.1414 8.70744L10.7697 16.6126C10.3109 17.1047 9.54006 17.1316 9.04803 16.6727L6.32348 14.1321C5.91345 13.7497 5.89102 13.1073 6.27337 12.6973C6.65573 12.2873 7.29808 12.2649 7.7081 12.6472L9.83873 14.6341L16.6565 7.32282C17.0389 6.91279 17.6812 6.89036 18.0912 7.27271Z"
        fill={color}
      />
    </svg>
  );
}

CheckIcon.propTypes = {
  color: PropTypes.string,
  containerColor: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.number,
};

CheckIcon.defaultProps = {
  color: 'var(--k-ds-color-white)',
  containerColor: 'var(--k-ds-color-interactive-primary)',
  label: 'Seleccionado',
  onClick: () => { },
  size: 24,
};

export default CheckIcon;
